var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirdIconYs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.798 54.748C116.798 54.748 84.5097 94.614 58.3984 105.848",
    stroke: "currentColor",
    strokeWidth: 5.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7305 110.006V123.463H86.4589",
    stroke: "currentColor",
    strokeWidth: 10.95,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.126 49.139L131.387 41.425L116.588 32.8564C114.983 28.8697 112.262 25.886 108.673 24.1371C103.9 21.8112 99.3596 22.3548 95.8085 23.6546C92.209 24.9727 89.1031 27.3676 86.6519 30.3155L15.168 116.28C41.5466 117.219 60.6962 106.7 60.6962 106.7L79.2958 106.702C118.497 102.74 117.883 70.1637 117.883 70.1637L118.126 49.139Z",
    stroke: "currentColor",
    strokeWidth: 10.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8984 41.976C94.8984 38.9511 97.35 36.5 100.373 36.5C103.397 36.5 105.848 38.9511 105.848 41.976C105.848 44.9989 103.397 47.45 100.373 47.45C97.35 47.45 94.8984 44.9989 94.8984 41.976Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdIconYs);
export default __webpack_public_path__ + "static/media/bird_icon_ys.0d01b5b6498cd747c9d45b18ab0a1cd3.svg";
export { ForwardRef as ReactComponent };